/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Col, Row, Form, Button, Layout, message } from "antd";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import logo from "../../config/img/logo-horizontal.png";
import { BRAND_NAME } from "../../config/config";
import LoginEmail from "./component/login_email";
import LoginPassword from "./component/login_password";
import LoginRemember from "./component/login_remember";
import { logIn } from "../../store/auth/auth.action";

import "./style.css";
const { Content } = Layout;

const LoginScreen = () => {
  // -------------------------- VAR --------------------------
  const [form] = Form.useForm();
  const { t } = useTranslation("translation", { keyPrefix: "login" });
  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- DATA FUNCTION --------------------------

  const onFinish = (values) => {
    setLoading(true);
    dispatch(
      logIn({ login: values }, (response) => {
        setLoading(false);
        if (response?.status === 500) {
          // failed
          const error = response.data;
          message.error(error);
        }
      })
    );
  };

  const onFinishFailed = (error) => {
    console.log({ error });
  };

  // -------------------------- RENDER --------------------------

  const renderBody = () => {
    const disabled = loading;
    return (
      <Form
        name="login_form"
        autoComplete="off"
        form={form}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[16, 0]}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <LoginEmail disabled={disabled} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <LoginPassword disabled={disabled} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <LoginRemember disabled={disabled} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            {renderButton()}
          </Col>
        </Row>
      </Form>
    );
  };

  const renderButton = () => {
    return (
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="login-form-button form-button"
          style={{ width: "100%", marginBottom: 10 }}
          loading={loading}
        >
          {t("login")}
        </Button>
        {/* Or <a href="/register">{t("register")}</a> */}
      </Form.Item>
    );
  };

  const renderCopyright = () => {
    return (
      <p variant="body2" color="textSecondary" align="center">
        {"Copyright © "}
        <a color="inherit" href="#" alt="Copyright">
          {BRAND_NAME}
        </a>{" "}
        {new Date().getFullYear()}
        {"."}
      </p>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Layout className="full">
      <Content className="login">
        <div className="center">
          <img src={logo} className="login-logo" alt="branch-logo" />
          {renderBody()}
        </div>
      </Content>
      {renderCopyright()}
    </Layout>
  );
};

export default LoginScreen;
